import * as React from 'react';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogTitle,
  Button,
  DialogHeader,
} from '../index';
import Icon from '../molecules/Icon';
import { Rocket, X } from 'lucide-react';

interface CreateFreeAccountConversationDialogProps {
  isOpen: boolean;
  onClose: (source?: 'close-icon' | 'back-button') => void;
  onCreate: () => void;
  isWeb: boolean;
  learnMoreUrl?: string;
}

export function CreateFreeAccountConversationDialog({
  isOpen,
  onClose,
  onCreate,
  isWeb,
}: CreateFreeAccountConversationDialogProps) {
  const handleDialogChange = (open: boolean) => {
    if (!open) {
      onClose('close-icon');
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleDialogChange}>
      <DialogContent className={`w-[450px] lg:w-[500px] flex flex-col`}>
        <DialogHeader className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Icon icon={Rocket} size={isWeb ? 22 : 18} strokeWidth={2} />
            <DialogTitle>Create free account</DialogTitle>
          </div>
          <button onClick={() => onClose('close-icon')} className="dialog-close-button">
            <Icon icon={X} color="#667085" strokeWidth={2.5} />
          </button>
        </DialogHeader>
        <div className="flex gap-8 ">
          <div>
            <img
              src="https://files.ideoz.ai/rocket.gif"
              alt="rocket"
              width="90"
              height="120"
            />
          </div>
          <div className="flex flex-col gap-3 ">
            <h3 className="text-lg font-semibold text-gray-900">
              Don't lose your breakthrough and save it as a project
            </h3>
            <p className="dialog-description">
              Just one step to save your progress and continue seamlessly. No sign-up required.
            </p>
          </div>
        </div>
        <DialogFooter>
          <Button
            variant="secondary-gray"
            size={isWeb ? 'sm' : 'xs'}
            onClick={() => onClose('back-button')}
          >
            Back
          </Button>
          <Button onClick={onCreate} variant="primary" size={isWeb ? 'sm' : 'xs'}>
            Create free account
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default CreateFreeAccountConversationDialog;
